<template>
  <div class="wrapper news">
    <!--<ul class="list" v-if="news.length">-->
      <!--<li v-for="(item, index) of news">-->
        <!--<router-link :to="{ name: 'news.detail', params: { id: item.id } }">-->
          <!--<div class="box">-->
            <!--<div class="middle">-->
              <!--<h3>VOL.{{item.index}} | {{ $t(`news.list[${index}].title`) }}</h3>-->
              <!--<span>{{item.createdAt | dateFormat}}</span>-->
            <!--</div>-->
          <!--</div>-->
        <!--</router-link>-->
      <!--</li>-->
      <!--<infinite-loading @infinite="infiniteHandler">-->
        <!--<span slot="no-more">-->
          <!--{{ $t('pages.news.no_more_result') }}-->
        <!--</span>-->
      <!--</infinite-loading>-->
    <!--</ul>-->
    <!--<div v-else class="no-more-result">{{ $t(`pages.news.no_more_result`) }}</div>-->
    <div class="list">
      <div class="business-title">{{$t('pages.news.business_modules_title')}}</div>
      <div class="bisiness-flex">
        <div class="business-single" v-for="item of $t('pages.news.business_modules')">
          <div class="business-img">
            <img :src="item.imgUrl" alt="">
          </div>
          <div class="business-single-title">{{item.title}}</div>
          <div class="business-content">{{item.introduce}}</div>
        </div>
      </div>
      <div class="business-title business-line">{{$t('pages.news.business_title')}}</div>
      <div class="bisiness-flex2-pc">
      <div class="bisiness-flex2">
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[0].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[0].introduce1')}}<br>
              {{$t('pages.news.businesses[0].introduce2')}}
          </div>
        </div>
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[1].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[1].introduce1')}}<br>
              {{$t('pages.news.businesses[1].introduce2')}}
          </div>
        </div>
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[2].title')}}</div>
          <div class="business-content">
              <span v-html="$t('pages.news.businesses[2].introduce1')"></span><br>
              <span v-html="$t('pages.news.businesses[2].introduce2')"></span>
          </div>
        </div>
      </div>
      <div class="bisiness-flex2">
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[3].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[3].introduce1')}}<br>
              {{$t('pages.news.businesses[3].introduce2')}}
          </div>
        </div>
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[4].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[4].introduce1')}}<br>
              {{$t('pages.news.businesses[4].introduce2')}}
          </div>
        </div>
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[5].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[5].introduce1')}}<br>
              {{$t('pages.news.businesses[5].introduce2')}}
          </div>
        </div>
      </div>
      <div class="bisiness-flex2">
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[6].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[6].introduce1')}}<br>
              {{$t('pages.news.businesses[6].introduce2')}}
          </div>
        </div>
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[7].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[7].introduce1')}}<br>
              {{$t('pages.news.businesses[7].introduce2')}}
          </div>
        </div>
        <div class="business-single">
          <div class="business-single-title">{{$t('pages.news.businesses[8].title')}}</div>
          <div class="business-content">
              {{$t('pages.news.businesses[8].introduce1')}}<br>
              {{$t('pages.news.businesses[8].introduce2')}}
          </div>
        </div>
      </div>
      </div>

      <div class="bisiness-flex2-mobile">
        <div class="bisiness-flex2">
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[0].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[0].introduce1')}}<br>
                {{$t('pages.news.businesses[0].introduce2')}}
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[1].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[1].introduce1')}}<br>
                {{$t('pages.news.businesses[1].introduce2')}}
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[2].title')}}</div>
            <div class="business-content">
                <span v-html="$t('pages.news.businesses[2].introduce1')"></span><br>
                <span v-html="$t('pages.news.businesses[2].introduce2')"></span>
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[3].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[3].introduce1')}}<br>
                {{$t('pages.news.businesses[3].introduce2')}}
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[4].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[4].introduce1')}}<br>
                {{$t('pages.news.businesses[4].introduce2')}}
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[5].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[5].introduce1')}}<br>
                {{$t('pages.news.businesses[5].introduce2')}}
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[6].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[6].introduce1')}}<br>
                {{$t('pages.news.businesses[6].introduce2')}}
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[7].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[7].introduce1')}}<br>
                {{$t('pages.news.businesses[7].introduce2')}}
            </div>
          </div>
          <div class="business-single">
            <div class="business-single-title">{{$t('pages.news.businesses[8].title')}}</div>
            <div class="business-content">
                {{$t('pages.news.businesses[8].introduce1')}}<br>
                {{$t('pages.news.businesses[8].introduce2')}}
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script type="text/ecmascript-6" lang="babel">
  import newsApi from '@/api/news';
  import dateFormat from '@/filters/date';
  import InfiniteLoading from 'vue-infinite-loading';

  export default {
    components: {
      InfiniteLoading
    },
    data() {
      return {
        news: [],
        currentPage: 1,
        pageSize: 10
      };
    },
    filters: {
      dateFormat
    },
    created() {
      this.loadMoreData();
    },
    methods: {
      infiniteHandler($state) {
        this.loadMoreData().then(({ content, totalElements }) => {
          if (content && content.length && this.news.length <= totalElements) {
            $state.loaded();
            return;
          }
          $state.complete();
        });
      },
      loadMoreData() {
        return newsApi.list({
          enable: 1,
          page: this.currentPage,
          rows: this.pageSize
        }).then((data) => {
          this.currentPage += 1;
          const { content } = data;
          this.news = this.news.concat(content.map((item, index) =>
            Object.assign({}, item, { index: content.length - index })
          ));
          // 设置国际化字符内容
          ['zh_cn', 'en'].forEach((lang) => {
            this.$i18n.mergeLocaleMessage(lang, {
              news: {
                list: this.news.map(item => Object.assign({}, item, item[lang]))
              }
            });
          });
          return data;
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/pages/news/list/list.vue